// extracted by mini-css-extract-plugin
module.exports = {"keyTemplates":"styles_keyTemplates__3H9GN"};